import 'vant/lib/calendar/index.less'

// 依赖
import '../preview-text/style'
